var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 97,
    viewBox: "0 0 77 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 1L1 29L4.5 35L6.5 39L11 43L19.5 45L20.5 49.5L22 53.5L24 54.5L25.5 58L26.5 56L29.5 58.5V62L32 67.5L31 73L26.5 72L29.5 77.5V80.5V95L76 48.5L29 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDc);
export default __webpack_public_path__ + "static/media/DC.9f2899cf29615897a352f3fe3cbc6aa5.svg";
export { ForwardRef as ReactComponent };